import * as Yup from 'yup';
import { 
    stringWithNoSpecialChars, 
    validateCivility, 
    validateDate, 
    validateEmail, 
    validateNumericId, 
    validatePassword, 
    validatePhone, 
    validateUserRole
} from "@/Shared/Helpers";
import { UserEnums } from '@/Shared';


export type UserFormValues = {
    id : number,
    person : {
        id : number
        lastname: string,
        firstname: string,
        civility: string,
        profession: string,
        birthDate: string,
        address: string,
        city: string,
        country: string,
        phone1: string,
        phone2: string,
        email: string,
    },
    hiredAt: string,
    firedAt: string,
    managerId: number,
    username : string,
    role : string,
    positions : string[],
};

export const UserValidationSchema = (viewEnums : UserEnums) => Yup.object({

    person: Yup.object({
    
        lastname: stringWithNoSpecialChars({ minLength: 2, maxLength: 50 }).required('Le nom est requis'),

        firstname: stringWithNoSpecialChars({ minLength: 2, maxLength: 50 }).required('Le prénom est requis'),

        email: validateEmail().required("L'email est requis"),

        profession: stringWithNoSpecialChars({ maxLength: 50 }).nullable(),

        address: stringWithNoSpecialChars({ maxLength: 100 }).nullable(),

        city: stringWithNoSpecialChars({ maxLength: 50 }).nullable(),

        country: stringWithNoSpecialChars({ maxLength: 50 }).nullable(),

        civility: validateCivility(viewEnums.CivilityEnum),

        birthDate: validateDate().nullable(),

        phone1: validatePhone().nullable(),

        phone2: validatePhone().nullable(), 
    }),

    hiredAt: validateDate().nullable(),

    firedAt: validateDate().nullable(),

    managerId: validateNumericId().notRequired(),

    username: stringWithNoSpecialChars({ minLength: 2, maxLength: 20 }).nullable(),

    role: validateUserRole(viewEnums.UserRoleEnum),
});


export type PasswordFormValues = {
    id : number,
    password : string,
    newPassword : string,
    passwordConfirmation : string,
}

export const PasswordValidationSchema = () =>
  Yup.object({
    password: validatePassword({ minLength: 4, maxLength: 12 })
      .required('Le mot de passe actuel est requis'),

    newPassword: validatePassword({ minLength: 4, maxLength: 12 })
      .required('Le nouveau mot de passe est requis')
      .oneOf([Yup.ref('newPassword')], 'Les mots de passe doivent être identiques'),

    passwordConfirmation: validatePassword({ minLength: 4, maxLength: 12 })
      .required('Le mot de passe de validation est requis')
      .oneOf([Yup.ref('newPassword')], 'Les mots de passe doivent être identiques'),
  });